<div class="slider-container">
  <div class="slider">
    @for (image of sliderImages; track $index) {
      <div class="slide">
          <picture>
            <img class="slide__picture" [src]="image" alt="Slide {{ $index + 1 }}" />
          </picture>
      </div>
    }
    @for (image of sliderImages; track $index) {
      <div class="slide">
        <picture >
          <source [srcset]="image" type="image/webp" />
          <source [srcset]="image" type="image/jpeg" />
          <img class="slide__picture" [src]="image" alt="Slide {{ $index + 1 }}" />
        </picture>
      </div>
    }
  </div>
</div>
